









import Vue from 'vue'
import Component from 'vue-class-component'
import { mapActions } from 'vuex'
import MapPoints from '../components/MapPoints.vue'

  @Component({
    components: {
      MapPoints
    },
    methods: {
      ...mapActions('lanterns', [
        'loadLanterns'
      ])
    },
    computed: {
      lanterns () {
        return this.$store.getters['lanterns/lanterns']
      }
    }
  })
export default class Map extends Vue {
    loadLanterns!: () => {}

  // mounted () {
  //   this.loadLanterns()
  // }
}
